import { post } from "@/utils/utils";

const okrWork = {
  state: {
    taskInfo: null
  },
  mutations: {
    QUERY_ALL_SHOP() {},
    GET_OKR_CATEGORYT_LIST() {},
    GET_OKR_BRANK_LIST() {},
    GET_OKR_SPU_LIST() {},
    GET_OKR_ATTRIBUTE_LIST() {},
    GET_OKR_ATTRIBUTE_NODE_LIST() {},
    SAVE_STORE_OKR_PLAN() {},
    QUERY_STORE_OKR_PLAN() {},
    SAVE_STORE_OKR_PLAN_SPLIT() {},
    QUERY_STORE_OKR_SHOP_PLAN() {},
    QUERY_STORE_OKR_BASIC_PLAN() {},
    SAVE_STORE_OKR_PLAN_SPLIT_SHOP() {},
    QUERY_STORE_OKR_TARGET_PLAN() {},
    SAVE_STORE_OKR_PLAN_SPLIT_TARGET() {},
    QUERY_STORE_OKR_TARGET_SHOP_PLAN_DETAILS() {},
    QUERY_STORE_OKR_TARGET_PLAN_DETAILS() {},
    QUERY_STORE_OKR_TARGET_AND_SHOP_PLAN_DETAILS() {},
    PUBLISH_STATUS() {},
    QUERY_STORE_OKR_PLAN_BASIC_DETAILS() {},
    QUERY_STORE_OKR_PLAN_SPLIT_DETAILS() {},
    EDIT_STORE_OKR_PLAN_SPLIT_SHOP() {},
    EDIT_STORE_OKR_PLAN_SPLIT_TARGET() {},
    EDIT_STORE_OKR_PLAN_SPLIT_INFO() {},
    EDIT_STORE_OKR_PLAN_BASIC_INFO() {},
    QUERY_OKR_PLAN_SPLIT_TARGET_INFO_BY_EMP() {},
    QUERY_STORE_OKR_TASK() {},
    SAVE_STORE_OKR_TASK_INFO() {},
    QUERY_SHOP_TARGET_SPLIT_INFO() {},
    UPDATE_OKR_TARGET_STATE() {},
    QUERY_STORE_OKR_TASK_DETAILS_STATE() {},
    QUERY_STORE_OKR_TASK_DETAILS() {},
    EDIT_STORE_OKR_TASK_DETAILS() {},
    QUERY_OKR_TARGET_SPLIT_CONFIRM() {},
    SAVE_OKR_TASK_CONFIRM_INFO() {},
    SAVE_OKR_TASK_SHOP_CONFIRM_INFO() {},
    QUERY_TARGET_SPLIT_SHOP_CONFIRM_INFO() {},
    SAVE_OKR_TASK_CONFIRM() {},
    QUERY_EXAMINE_GROUP_LIST() {},
    ADD_EXAMINE_GROUP() {},
    QUERY_GROUP_DETAILS() {},
    CHANGE_GROUP_STATUS() {},
    EDIT_EXAMINE_GROUP() {},
    QUERY_EXAMINE_LEVEL_LIST() {},
    ADD_EXAMINE_LEVEL() {},
    QUERY_LEVEL_DETAILS() {},
    EDIT_EXAMINE_LEVEL() {},
    QUERY_FIELD_TEMP_TYPE() {},
    ADD_INDICATOR_FIELD() {},
    QUERY_INDICATOR_FIELD_LIST() {},
    QUERY_INDICATOR_FIELD_DETAILS() {},
    EDIT_INDICATOR_FIELD() {},
    CHANGE_INDICATOR_FIELD_STATUS() {},
    SAVE_TASK_INFO(state, data) {
      state.taskInfo = data;
    },
    QUERY_CUSTOM_TEMPLATE() {},
    QUERY_FIELD() {},
    QUERY_TARGET_TASK_LIST() {},
    ADD_EXAMINE_TASK() {},
    QUERY_TARGET_TASK_DETAILS() {},
    QUERY_TARGET_LIST() {},
    EDIT_EXAMINE_TASK() {},
    TASK_RELATION_LEVEL() {},
    CHANGE_EXAMINE_TASK_STATUS() {},
    QUERY_TASK_RESULT_LIST() {},
    QUERY_TARGET_SPLIT_DETAIL() {},
    QUERY_TARGET_SPLIT_GOODS_DETAIL() {},
    QUERY_TARGET_SPLIT_EMP_DETAIL() {},
    QUERY_STORE_OKR_PLAN_DETAIL() {},
    QUERY_STORE_OKR_PLAN_FORNO_DETAIL() {},
    QUERY_STORE_OKR_PLAN_FOR_SPLIT() {},
    QUERY_STORE_OKR_PLAN_EMP_DETAILS() {},
    QUERY_OKR_PLAN_SPLIT_TARGET_DETAILS() {},
    QUERY_STORE_DEPART_INFO() {},
    QUERY_USER_STORE_DEPART_INFO() {},
    SAVE_OKR_LEADER_CHOICE() {},
    QUERY_OKR_LEADER_CHOICE() {},
    DEL_OKR_LEADER_CHOICE() {},
    QUERY_EXAMINE_GROUP_LIST_BY_ID() {},
    QUERY_EXAMINE_LEVEL_BY_ID() {},
    QUERY_EMPLOYEE_SCORE_LIST() {},
    QUERY_EMPLOYEE_SCORE_TABLE_HEADER() {},
    QUERY_TASK_FIELD_LIST() {},
    BATCH_UPDATE_RATING() {},
    QUERY_RATING_LOG() {},
    SAVE_ROW_RATING() {},
    QUERY_SCORE_FILTER_FIELD() {},
    IMPORT_RATING_FILE() {}
    // QUERY_OKR_PLAN_SPLIT_TARGET_DETAILS() {}
  },
  actions: {
    importRatingFile({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/importExcel`,
        name: "IMPORT_RATING_FILE",
        params
      });
    },
    queryScoreFilterField({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/queryScoreColumnList`,
        name: "QUERY_SCORE_FILTER_FIELD",
        params
      });
    },
    saveRowRating({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/batchEditTaskScore`,
        name: "SAVE_ROW_RATING",
        params
      });
    },
    queryRatingLog({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/queryLogList`,
        name: "QUERY_RATING_LOG",
        params
      });
    },
    batchUpdateRating({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/batchUpdate`,
        name: "BATCH_UPDATE_RATING",
        params
      });
    },
    queryTaskFieldList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/queryScoreDetail`,
        name: "QUERY_TASK_FIELD_LIST",
        params
      });
    },
    queryEmployeeScoreTableHeader({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/queryTitleList`,
        name: "QUERY_EMPLOYEE_SCORE_TABLE_HEADER",
        params
      });
    },
    queryEmployeeScoreList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskColumnsScore/queryDetailList`,
        name: "QUERY_EMPLOYEE_SCORE_LIST",
        params
      });
    },
    queryTaskResultList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsGroupEmployeeInfo/queryPageList`,
        name: "QUERY_TASK_RESULT_LIST",
        params
      });
    },
    taskRelationLevel({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsLevelInfo/bindTaskAndLevel`,
        name: "TASK_RELATION_LEVEL",
        params
      });
    },
    changeExamineTaskStatus({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/updateStatus`,
        name: "CHANGE_EXAMINE_TASK_STATUS",
        params
      });
    },
    addExamineTask({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/add`,
        name: "ADD_EXAMINE_TASK",
        params
      });
    },
    editExamineTask({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/edit`,
        name: "EDIT_EXAMINE_TASK",
        params
      });
    },
    queryTargetTaskList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/queryPageList`,
        name: "QUERY_TARGET_TASK_LIST",
        params
      });
    },
    queryTargetList({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryOkrPlanSplitTargetInfoList`,
        name: "QUERY_TARGET_LIST",
        params
      });
    },
    queryTargetTaskDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/queryById`,
        name: "QUERY_TARGET_TASK_DETAILS",
        params
      });
    },
    queryField({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/getCustomCloumList`,
        name: "QUERY_FIELD",
        params
      });
    },
    queryCustomTemplate({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/getCloumListByDictCode`,
        name: "QUERY_CUSTOM_TEMPLATE",
        params
      });
    },
    queryFieldTempType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=EMP_MERITS_TEMP`,
        name: "QUERY_FIELD_TEMP_TYPE",
        params
      });
    },
    queryIndicatorFieldList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/queryPageList`,
        name: "QUERY_INDICATOR_FIELD_LIST",
        params
      });
    },
    queryIndicatorFieldDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/queryById`,
        name: "QUERY_INDICATOR_FIELD_DETAILS",
        params
      });
    },
    addIndicatorField({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/add`,
        name: "ADD_INDICATOR_FIELD",
        params
      });
    },
    editIndicatorField({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/edit`,
        name: "EDIT_INDICATOR_FIELD",
        params
      });
    },
    changeIndicatorFieldStatus({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsColumnsInfo/updateStatus`,
        name: "CHANGE_INDICATOR_FIELD_STATUS",
        params
      });
    },
    queryExamineLevelList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsLevelInfo/queryPageList`,
        name: "QUERY_EXAMINE_LEVEL_LIST",
        params
      });
    },
    queryExamineGroupList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsGroupInfo/queryPageList`,
        name: "QUERY_EXAMINE_GROUP_LIST",
        params
      });
    },
    queryExamineGroupListById({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/queryGroupListById`,
        name: "QUERY_EXAMINE_GROUP_LIST_BY_ID",
        params
      });
    },
    addExamineLevel({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsLevelInfo/add`,
        name: "ADD_EXAMINE_LEVEL",
        params
      });
    },
    addExamineGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsGroupInfo/add`,
        name: "ADD_EXAMINE_GROUP",
        params
      });
    },
    editExamineGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsGroupInfo/edit`,
        name: "EDIT_EXAMINE_GROUP",
        params
      });
    },
    editExamineLevel({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsLevelInfo/edit`,
        name: "EDIT_EXAMINE_LEVEL",
        params
      });
    },
    queryExamineLevelById({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsTaskInfo/queryLevelPointListById`,
        name: "QUERY_EXAMINE_LEVEL_BY_ID",
        params
      });
    },
    queryLevelDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsLevelInfo/queryById`,
        name: "QUERY_LEVEL_DETAILS",
        params
      });
    },
    queryGroupDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsGroupInfo/queryById`,
        name: "QUERY_GROUP_DETAILS",
        params
      });
    },
    changeGroupDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmpMeritsGroupInfo/updateStatus`,
        name: "CHANGE_GROUP_STATUS",
        params
      });
    },
    queryAllShop({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryAllShop`,
        name: "QUERY_ALL_SHOP",
        params
      });
    },
    getOrkCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/basic/category/getCategoryList`,
        name: "GET_OKR_CATEGORYT_LIST",
        params
      });
    },
    getOrkBrankList({ commit }, params) {
      return post({
        commit,
        url: `/basic/brand/basic_list_new`,
        name: "GET_OKR_BRANK_LIST",
        params
      });
    },
    getOrkSpuList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/getSpuListForOkr`,
        name: "GET_OKR_SPU_LIST",
        params
      });
    },
    getOrkAttributeList({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/getPromotionAttributeTypeNew`,
        name: "GET_OKR_ATTRIBUTE_LIST",
        params
      });
    },
    getOrkAttributeNodeList({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/getPromotionTypeValueNew`,
        name: "GET_OKR_ATTRIBUTE_NODE_LIST",
        params
      });
    },
    saveStoreOkrPlanBasicInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveStoreOkrPlanBasicInfo`,
        name: "SAVE_STORE_OKR_PLAN",
        params
      });
    },
    queryStoreOkrPlanSplitInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanSplitInfo`,
        name: "QUERY_STORE_OKR_PLAN",
        params
      });
    },
    saveStoreOkrPlanSplitInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveStoreOkrPlanSplitInfo`,
        name: "SAVE_STORE_OKR_PLAN_SPLIT",
        params
      });
    },
    queryStoreOkrPlanSplitShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanSplitShopInfo`,
        name: "QUERY_STORE_OKR_SHOP_PLAN",
        params
      });
    },
    queryStoreOkrPlanBasicInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanBasicInfo`,
        name: "QUERY_STORE_OKR_BASIC_PLAN",
        params
      });
    },
    saveStoreOkrPlanSplitShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveStoreOkrPlanSplitShopInfo`,
        name: "SAVE_STORE_OKR_PLAN_SPLIT_SHOP",
        params
      });
    },
    queryStoreOkrPlanSplitTargetInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanSplitTargetInfo`,
        name: "QUERY_STORE_OKR_TARGET_PLAN",
        params
      });
    },
    saveStoreOkrPlanSplitTargetInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveStoreOkrPlanSplitTargetInfo`,
        name: "SAVE_STORE_OKR_PLAN_SPLIT_TARGET",
        params
      });
    },
    queryStoreOkrPlanSplitShopDetailsInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanSplitShopDetailsInfo`,
        name: "QUERY_STORE_OKR_TARGET_SHOP_PLAN_DETAILS",
        params
      });
    },
    queryStoreOkrPlanSplitTargetDetailsInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanSplitTargetDetailsInfo`,
        name: "QUERY_STORE_OKR_TARGET_PLAN_DETAILS",
        params
      });
    },
    queryOkrPlanShopAndTargetDetailsInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryOkrPlanShopAndTargetDetailsInfo`,
        name: "QUERY_STORE_OKR_TARGET_AND_SHOP_PLAN_DETAILS",
        params
      });
    },
    changePublishStatus({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/changePublishStatus`,
        name: "PUBLISH_STATUS",
        params
      });
    },
    queryStoreOkrPlanBasicDetailsInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanBasicDetailsInfo`,
        name: "QUERY_STORE_OKR_PLAN_BASIC_DETAILS",
        params
      });
    },
    queryStoreOkrPlanSplitDetailsInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanSplitDetailsInfo`,
        name: "QUERY_STORE_OKR_PLAN_SPLIT_DETAILS",
        params
      });
    },
    editStoreOkrPlanSplitShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/editStoreOkrPlanSplitShopInfo`,
        name: "EDIT_STORE_OKR_PLAN_SPLIT_SHOP",
        params
      });
    },
    editStoreOkrPlanSplitTargetInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/editStoreOkrPlanSplitTargetInfo`,
        name: "EDIT_STORE_OKR_PLAN_SPLIT_TARGET",
        params
      });
    },
    editStoreOkrPlanSplitInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/editStoreOkrPlanSplitInfo`,
        name: "EDIT_STORE_OKR_PLAN_SPLIT_INFO",
        params
      });
    },
    editStoreOkrPlanBasicInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/editStoreOkrPlanBasicInfo`,
        name: "EDIT_STORE_OKR_PLAN_BASIC_INFO",
        params
      });
    },
    queryOkrPlanSplitTargetInfoByEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryOkrPlanSplitTargetInfoByEmployee`,
        name: "QUERY_OKR_PLAN_SPLIT_TARGET_INFO_BY_EMP",
        params
      });
    },
    queryStoreOkrTaskDetailInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrTaskDetailInfo`,
        name: "QUERY_STORE_OKR_TASK",
        params
      });
    },
    saveStoreOkrTaskDetailInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveStoreOkrTaskDetailInfo`,
        name: "SAVE_STORE_OKR_TASK_INFO",
        params
      });
    },
    queryShopTargetSplitInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryShopTargetSplitInfo`,
        name: "QUERY_SHOP_TARGET_SPLIT_INFO",
        params
      });
    },
    updateOkrTargetSplitState({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/updateOkrTargetSplitState`,
        name: "UPDATE_OKR_TARGET_STATE",
        params
      });
    },
    queryStoreOkrTaskDetailInfoState({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrTaskDetailInfoState`,
        name: "QUERY_STORE_OKR_TASK_DETAILS_STATE",
        params
      });
    },
    queryStoreOkrTaskDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrTaskDetails`,
        name: "QUERY_STORE_OKR_TASK_DETAILS",
        params
      });
    },
    editOkrTargetSplitInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/editOkrTargetSplitInfo`,
        name: "EDIT_STORE_OKR_TASK_DETAILS",
        params
      });
    },
    queryOkrTargetSplitConfirmInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryOkrTargetSplitConfirmInfo`,
        name: "QUERY_OKR_TARGET_SPLIT_CONFIRM",
        params
      });
    },
    saveOkrTaskDetailConfirmInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveOkrTaskDetailConfirmInfo`,
        name: "SAVE_OKR_TASK_CONFIRM_INFO",
        params
      });
    },
    saveOkrTaskShopConfirmInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveOkrTaskShopConfirmInfo`,
        name: "SAVE_OKR_TASK_SHOP_CONFIRM_INFO",
        params
      });
    },
    queryTargetSplitShopConfirmInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryTargetSplitShopConfirmInfo`,
        name: "QUERY_TARGET_SPLIT_SHOP_CONFIRM_INFO",
        params
      });
    },
    saveOkrTaskConfirmInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveOkrTaskConfirmInfo`,
        name: "SAVE_OKR_TASK_CONFIRM",
        params
      });
    },
    queryTargetSplitDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryTargetSplitDetail`,
        name: "QUERY_TARGET_SPLIT_DETAIL",
        params
      });
    },
    queryTargetSplitGoodsDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryTargetSplitGoodsDetail`,
        name: "QUERY_TARGET_SPLIT_GOODS_DETAIL",
        params
      });
    },
    queryTargetSplitEmployeeDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryTargetSplitEmployeeDetail`,
        name: "QUERY_TARGET_SPLIT_EMP_DETAIL",
        params
      });
    },
    queryStoreOkrPlanBasicList({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanBasicList`,
        name: "QUERY_STORE_OKR_PLAN_DETAIL",
        params
      });
    },
    queryStoreOkrPlanForNoSplit({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanForNoSplit`,
        name: "QUERY_STORE_OKR_PLAN_FORNO_DETAIL",
        params
      });
    },
    queryStoreOkrPlanForSplit({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanForSplit`,
        name: "QUERY_STORE_OKR_PLAN_FOR_SPLIT",
        params
      });
    },
    queryStoreOkrPlanEmployeeDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryStoreOkrPlanEmployeeDetail`,
        name: "QUERY_STORE_OKR_PLAN_EMP_DETAILS",
        params
      });
    },
    queryOkrPlanSplitTargetInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryOkrPlanSplitTargetInfo`,
        name: "QUERY_OKR_PLAN_SPLIT_TARGET_DETAILS",
        params
      });
    },
    queryStoreDepartInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/queryStoreDepartInfoList`,
        name: "QUERY_STORE_DEPART_INFO",
        params
      });
    },
    queryUserStoreDepartInfoList({ commit }, params) {
      return post({
        commit,
        url: `sys/user/queryEmployeeListByRoleId`,
        name: "QUERY_USER_STORE_DEPART_INFO",
        params
      });
    },
    saveOkrLeaderChoiceRecord({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/saveOkrLeaderChoiceRecord`,
        name: "SAVE_OKR_LEADER_CHOICE",
        params
      });
    },
    queryOkrLeaderChoiceRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/queryOkrLeaderChoiceRecordList`,
        name: "QUERY_OKR_LEADER_CHOICE",
        params
      });
    },
    delOkrLeaderChoiceRecord({ commit }, params) {
      return post({
        commit,
        url: `/store/okr/delOkrLeaderChoiceRecord`,
        name: "DEL_OKR_LEADER_CHOICE",
        params
      });
    }
  }
};

export default okrWork;
